/* Skinlab: kommer snart (sections/laserlab-skinlab-teaser.liquid). The page's one sign-up, in a dialog.
   - It opens from every «Meld meg på» ([data-skinlab-open]), from links on this page to #skinlab-venteliste or
     #nyhetsbrev, and on arrival at /pages/skinlab#skinlab-venteliste. Never by itself otherwise: no timer, no scroll.
   - After Shopify's reload (?customer_posted=true#<form id>) it opens with the result (thanks, error, already
     registered), but only when the post was this form's: the hash is the form's id, or the stamp set on submit is
     under 30 minutes old. Otherwise the form is shown fresh.
   - The address bar is cleaned only when the dialog closes, never on load.
   - The launch-date line counts whole days in Oslo time and changes at most once a day.
   - The menu card turns on a tap, spins when dragged, dips under a press and floats while the cover is up (initMenu).
   The star's clock lives in laserlab-site.js (one star plan for the site). */
(() => {
  const STAMP = 'll-skinlab-posted';
  const stamp = {
    get() { try { return Number(sessionStorage.getItem(STAMP)) || 0; } catch (error) { return 0; } },
    set(value) { try { if (value) sessionStorage.setItem(STAMP, String(value)); else sessionStorage.removeItem(STAMP); } catch (error) { /* the hash alone still works */ } }
  };
  const isDone = view => view === 'success' || view === 'exists';

  const init = section => {
    if (!section || section.dataset.skinlabReady) return;
    section.dataset.skinlabReady = 'true';
    const dialog = section.querySelector('.ll-skinlab-signup');
    const form = dialog?.querySelector('form');
    const field = form?.querySelector('input[type="email"]');
    if (!dialog || !form || !field) return;
    const askTitle = dialog.querySelector('[data-skinlab-title]');
    const doneTitle = dialog.querySelector('[data-skinlab-done-title]');
    const heroCta = section.querySelector('.ll-skinlab-teaser__cta');
    const heroDone = section.querySelector('.ll-skinlab-teaser__done');
    const modal = typeof dialog.showModal === 'function';
    if (!modal) document.documentElement.classList.add('ll-skinlab-inline');
    let opener = null;

    const setView = view => {
      dialog.dataset.view = view;
      dialog.setAttribute('aria-labelledby', (isDone(view) ? doneTitle : askTitle).id);
    };
    const clearError = () => {
      dialog.querySelector('.ll-skinlab-signup__error')?.remove();
      field.removeAttribute('aria-invalid');
      field.setAttribute('aria-describedby', field.getAttribute('aria-describedby').split(' ').filter(id => document.getElementById(id)).join(' '));
      field.value = '';
    };
    const open = from => {
      const target = isDone(dialog.dataset.view) ? doneTitle : field;
      if (!modal) {
        dialog.scrollIntoView({ block: 'start' });
        target.focus({ preventScroll: true });
        return;
      }
      if (dialog.open) return;
      opener = from || null;
      dialog.querySelectorAll('[autofocus]').forEach(element => element.removeAttribute('autofocus'));
      target.setAttribute('autofocus', '');
      dialog.showModal();
      target.focus({ preventScroll: true });
    };
    /* Chrome handles the address's #fragment after this script: it moves focus to the dialog (#skinlab-venteliste),
       or clears it when the fragment is the form (after a sign-up). A dialog opened on arrival takes its focus back
       once the page has loaded, unless the visitor is already inside it. */
    const settle = () => {
      const again = () => setTimeout(() => {
        const active = document.activeElement;
        if (!dialog.open || (active && active !== dialog && dialog.contains(active))) return;
        (isDone(dialog.dataset.view) ? doneTitle : field).focus({ preventScroll: true });
      }, 0);
      if (document.readyState === 'complete') again(); else window.addEventListener('load', again, { once: true });
    };
    const cleanUrl = () => {
      const url = new URL(window.location.href);
      [...url.searchParams.keys()].filter(key => key === 'customer_posted' || key === 'form_type' || key === 'utf8' || key.startsWith('contact')).forEach(key => url.searchParams.delete(key));
      history.replaceState(history.state, '', url.pathname + url.search);
    };

    dialog.addEventListener('close', () => {
      if (dialog.open) return; /* reopened at once (the submit below, or the back-forward cache): not a close */
      delete dialog.dataset.loose;
      cleanUrl();
      const back = opener?.isConnected && opener.getClientRects().length ? opener : (section.hasAttribute('data-done') ? heroDone : heroCta);
      opener = null;
      back?.focus({ preventScroll: true });
    });
    let pressedOutside = false;
    dialog.addEventListener('pointerdown', event => { pressedOutside = event.target === dialog; });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-skinlab-close]')) dialog.close();
      else if (pressedOutside && event.target === dialog) dialog.close();
      pressedOutside = false;
    });
    document.addEventListener('click', event => {
      if (!section.isConnected || !(event.target instanceof Element)) return;
      const trigger = event.target.closest('[data-skinlab-open], a[href*="#skinlab-venteliste"], a[href*="#nyhetsbrev"]');
      if (!trigger || (trigger.matches('a') && trigger.pathname !== window.location.pathname)) return;
      event.preventDefault();
      open(trigger);
    });
    form.addEventListener('submit', event => {
      if (form.dataset.sending) { event.preventDefault(); return; }
      form.dataset.sending = 'true';
      stamp.set(Date.now());
      /* Shopify's hCaptcha opens any challenge in <body>, which a modal dialog makes inert and covers. Keep the card
         where it is and drop the modality until the page leaves (styled by [data-loose]). */
      if (modal && dialog.open && !('loose' in dialog.dataset)) {
        const active = document.activeElement;
        dialog.dataset.loose = '';
        dialog.close();
        dialog.show();
        active?.focus({ preventScroll: true });
      }
    });
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      delete form.dataset.sending;
      if (dialog.open && 'loose' in dialog.dataset) { delete dialog.dataset.loose; dialog.close(); dialog.showModal(); }
    });

    const preview = window.Shopify?.designMode ? section.dataset.preview : '';
    const state = section.dataset.state || 'default';
    if (preview && preview !== 'none') {
      setView(preview);
      open(null);
      settle();
      document.addEventListener('shopify:section:select', event => { if (event.target.contains(section)) open(null); });
    } else if (state !== 'default') {
      const ours = window.location.hash === `#${form.id}` || Date.now() - stamp.get() < 30 * 60 * 1000;
      stamp.set(0);
      if (ours) {
        setView(state);
        if (state === 'success') section.setAttribute('data-done', '');
        open(null);
        settle();
      } else {
        setView('default');
        clearError();
      }
    } else if (window.location.hash === '#skinlab-venteliste') {
      open(null);
      settle();
    }

    const when = section.querySelector('time[data-skinlab-launch]');
    if (when) {
      const osloToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      const utc = iso => { const [y, m, d] = iso.split('-').map(Number); return Date.UTC(y, m - 1, d); };
      const say = () => {
        const days = Math.round((utc(when.dateTime) - utc(osloToday())) / 864e5);
        const text = days > 1 ? `Åpner om ${days} dager` : days === 1 ? 'Åpner i morgen' : days === 0 ? 'Åpner i dag' : when.dataset.fallback;
        if (!text) { when.closest('.ll-skinlab-teaser__kicker').hidden = true; return; }
        if (when.textContent !== text) when.textContent = text;
      };
      say();
      document.addEventListener('visibilitychange', () => { if (!document.hidden) say(); });
      setInterval(say, 60 * 1000);
    }
  };

  /* The menu card (28.09, the owner: «et kort som beveger seg litt … føles nesten litt 3d men er flat», «trykker på
     menyen, så snur den seg», «mer bevegelse, at den beveger seg etter touch … og at jeg kan snurre den»).
     - A tap anywhere turns it over, a half turn always the same way round (not when the tap ends a text selection).
       The cover has «Sniktitt på menyen»; the inside's button shows only on keyboard focus; Esc turns the card back.
     - Dragged sideways (finger or mouse) it spins with the pointer; let go, it coasts on with the flick's speed and
       lands on the nearest face, so one hard flick spins it round several times.
     - A press tilts it towards the finger; a mouse tilts it just by pointing (up to 5°), on top of the float.
     - While the cover is up and in view, it floats: a slow bob and sway, on desktop too, until it is dragged or
       turned (the owner: «helt til man selv vrir på den med musa»); it rests 3 s after that, then floats again.
       The first time it comes into view it also peeks a quarter round, to show it has a back. The inside keeps
       still for reading.
     - «Reduce motion»: none of this; a tap swaps the faces at once.
     One frame loop draws the tilt, float and peek, and runs only while something moves. The turn itself is the
     stylesheet's transition to --sk-turn. The hidden face is inert, and focus follows the face that is up. In the
     theme editor, selecting a category turns the card to show it. */
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const TILT = 5;
  const PRESS = 6;
  const SPIN = 200;   /* degrees per card width dragged */
  const inOut = x => (x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
  const initMenu = menu => {
    if (!menu || menu.dataset.ready) return;
    const cover = menu.querySelector('[data-face="cover"]');
    const inside = menu.querySelector('[data-face="inside"]');
    const open = cover?.querySelector('[data-skinlab-turn]');
    const list = inside?.querySelector('ol');
    const tilt = menu.querySelector('.ll-skinlab-teaser__tilt');
    const sheet = menu.querySelector('.ll-skinlab-teaser__sheet');
    if (!cover || !inside || !open || !tilt || !sheet) return;
    menu.dataset.ready = 'true';

    /* The turn: angle in degrees, a multiple of 180 at rest; odd half turns show the inside. */
    let angle = 0;
    let restUntil = 0;
    const touch = () => {
      restUntil = performance.now() + 3000;
      setTimeout(() => wake(), 3050);
    };
    const insideUp = () => Math.abs(Math.round(angle / 180)) % 2 === 1;
    const settle = moveFocus => {
      const turned = insideUp();
      menu.toggleAttribute('data-turned', turned);
      open.setAttribute('aria-expanded', String(turned));
      cover.inert = turned;
      inside.inert = !turned;
      if (moveFocus) (turned ? list : open)?.focus({ preventScroll: true });
    };
    const spinTo = (deg, ms, curve) => {
      angle = deg;
      sheet.style.transition = ms && !still.matches ? `transform ${ms}ms ${curve}` : 'none';
      sheet.style.setProperty('--sk-turn', `${deg}deg`);
    };
    const turn = moveFocus => {
      touch();
      spinTo(Math.round(angle / 180) * 180 - 180, 700, 'cubic-bezier(.4, 0, .2, 1)');
      settle(moveFocus);
      wake();
    };

    /* Tilt, float and peek: one frame loop. */
    let tx = 0;
    let ty = 0;
    let aimX = 0;
    let aimY = 0;
    let amp = 0;
    let visible = false;
    let hovering = false;
    let drag = null;
    let peekAt = -1;
    let frame = 0;
    let last = 0;
    let clock = 0;
    const floating = () => visible && performance.now() > restUntil && !(drag && drag.moved) && !insideUp() && !still.matches;
    const draw = now => {
      frame = 0;
      if (still.matches) { tilt.style.transform = ''; return; }
      const dt = last ? Math.min(now - last, 64) : 16;
      last = now;
      clock += dt;
      const follow = 1 - Math.pow(.8, dt / 16.7);
      tx += (aimX - tx) * follow;
      ty += (aimY - ty) * follow;
      amp += ((floating() ? 1 : 0) - amp) * (1 - Math.pow(.95, dt / 16.7));
      const s = clock / 1000;
      let peek = 0;
      if (peekAt >= 0 && now >= peekAt) {
        const p = (now - peekAt) / 1600;
        if (p >= 1) peekAt = -1;
        else peek = -26 * Math.sin(Math.PI * inOut(p));
      }
      const lift = amp * 5 * (Math.cos(2 * Math.PI * s / 4.5) - 1);
      const rx = tx + amp * 2 * Math.cos(2 * Math.PI * s / 6);
      const ry = ty + amp * 3.5 * Math.sin(2 * Math.PI * s / 6) + peek;
      tilt.style.transform = `translateY(${lift.toFixed(2)}px) rotateX(${rx.toFixed(3)}deg) rotateY(${ry.toFixed(3)}deg)`;
      const busy = floating() || amp > .002 || peekAt >= 0 || Math.abs(aimX - tx) > .01 || Math.abs(aimY - ty) > .01;
      if (busy) frame = requestAnimationFrame(draw);
      else last = 0;
    };
    const wake = () => { if (!frame && !still.matches) frame = requestAnimationFrame(draw); };
    const aimAt = (x, y, max) => {
      const box = menu.getBoundingClientRect();
      aimY = (Math.min(Math.max((x - box.left) / box.width, 0), 1) - .5) * 2 * max;
      aimX = -(Math.min(Math.max((y - box.top) / box.height, 0), 1) - .5) * 2 * max;
      wake();
    };
    const release = () => { aimX = 0; aimY = 0; wake(); };

    /* Pointer: tilt, press, spin. */
    let pressTimer = 0;
    let swallowClick = false;
    menu.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; wake(); } });
    menu.addEventListener('pointerleave', event => {
      if (event.pointerType !== 'mouse') return;
      hovering = false;
      if (!drag) release();
    });
    menu.addEventListener('pointerdown', event => {
      swallowClick = false;
      if (still.matches || (event.pointerType === 'mouse' && event.button !== 0)) return;
      drag = { id: event.pointerId, type: event.pointerType, x: event.clientX, y: event.clientY, from: angle, moved: false, trail: [[event.timeStamp, event.clientX]] };
      if (event.pointerType !== 'mouse') {
        clearTimeout(pressTimer);
        /* A press, not the start of a scroll: wait a moment before the card dips. */
        pressTimer = setTimeout(() => { if (drag && !drag.moved) aimAt(drag.x, drag.y, PRESS); }, 70);
      }
    });
    menu.addEventListener('pointermove', event => {
      if (!drag) {
        if (event.pointerType === 'mouse' && fine.matches && !still.matches) aimAt(event.clientX, event.clientY, TILT);
        return;
      }
      if (event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (!drag.moved) {
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        drag.moved = true;
        touch();
        clearTimeout(pressTimer);
        menu.classList.add('is-spinning');
        try { menu.setPointerCapture(event.pointerId); } catch (error) { /* the card still follows */ }
      }
      const width = menu.getBoundingClientRect().width || 1;
      spinTo(drag.from + (dx / width) * SPIN, 0);
      drag.trail.push([event.timeStamp, event.clientX]);
      while (drag.trail.length > 2 && event.timeStamp - drag.trail[0][0] > 100) drag.trail.shift();
      aimX = -(Math.min(Math.max((event.clientY - menu.getBoundingClientRect().top) / menu.getBoundingClientRect().height, 0), 1) - .5) * 2 * PRESS;
      aimY = 0;
      wake();
    });
    const end = event => {
      if (!drag || event.pointerId !== drag.id) return;
      const done = drag;
      drag = null;
      clearTimeout(pressTimer);
      if (!(hovering && done.type === 'mouse')) release();
      if (!done.moved) return;
      menu.classList.remove('is-spinning');
      swallowClick = true;
      /* The flick's speed over its last 100 ms (at least 16 ms of it), carried 300 ms on, at most three half turns. */
      const width = menu.getBoundingClientRect().width || 1;
      const [t0, x0] = done.trail[0];
      const [t1, x1] = done.trail[done.trail.length - 1];
      const speed = t1 - t0 >= 16 && event.timeStamp - t1 < 80 ? ((x1 - x0) / (t1 - t0)) * (SPIN / width) : 0;
      const coast = Math.max(-540, Math.min(540, speed * 300));
      const target = Math.round((angle + coast) / 180) * 180;
      spinTo(target, Math.round(Math.min(1600, 420 + Math.abs(target - angle) * 2.4)), 'cubic-bezier(.15, .6, .2, 1)');
      settle(false);
      wake();
    };
    menu.addEventListener('pointerup', end);
    menu.addEventListener('pointercancel', end);
    /* Only the card's own capture: taking it over from the pressed child fires (and bubbles) the child's. */
    menu.addEventListener('lostpointercapture', event => { if (event.target === menu) end(event); });

    menu.addEventListener('click', event => {
      if (swallowClick) { swallowClick = false; return; }
      const face = event.target instanceof Element ? event.target.closest('[data-face]') : null;
      if (!face || face.inert) return;
      const control = event.target.closest('a, button, input, select, textarea, summary, label');
      if (control && !control.hasAttribute('data-skinlab-turn')) return;
      if (!control && String(window.getSelection?.() || '').trim()) return;
      turn(true);
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !insideUp()) return;
      event.preventDefault();
      turn(true);
    });
    document.addEventListener('shopify:block:select', event => { if (menu.contains(event.target) && !insideUp()) turn(false); });
    still.addEventListener('change', () => {
      aimX = 0; aimY = 0; tx = 0; ty = 0; amp = 0; peekAt = -1;
      tilt.style.transform = '';
      spinTo(Math.round(angle / 180) * 180, 0);
      wake();
    });

    let peeked = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => entries.forEach(entry => {
        visible = entry.isIntersecting;
        if (visible && !peeked && !restUntil && !still.matches) {
          peeked = true;
          peekAt = performance.now() + 250;
        }
        wake();
      }), { threshold: .35 }).observe(menu);
    }
    settle(false);
  };

  const start = () => {
    document.querySelectorAll('[data-skinlab]').forEach(init);
    document.querySelectorAll('[data-skinlab-menu]').forEach(initMenu);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-skinlab]').forEach(init);
    event.target.querySelectorAll('[data-skinlab-menu]').forEach(initMenu);
  });
})();
